import BookingsListPage from '../../shared/booking/BookingsListPage';

export default function HotelBookings() {
  return <BookingsListPage module="hotels" title="My hotel bookings" />;
}
